import { AppBar, makeStyles, styled } from "@material-ui/core";
import { Linked, useIO, useLinked, useModel } from "@type-r/react";
import { Column, Columns, Flex, Loading, Page, SelectSortBy, TilesList, Toolbar } from "lqx-react";
import * as React from "react";
import { useMemo } from "react";
import { RowH1 } from "../../../../../common";
import { UnappliedCashVaultCard, UnappliedCashVaultPage } from "../api/unappliedCash";
import { AddFilter } from "../components/search-bar/search-bar";
import { CountListSection } from "../count-list-section";
import { SortOptions } from "./models/unapplied-cash-filter";
import { UnappliedCashStore } from "./models/unapplied-cash-store";
import { UnappliedCashVaultCardRenderer } from './unapplied-cashes-card-renderer';
import { UnappliedCashDetailsPane } from "./unapplied-cashes-details-pane";

export const UnappliedCashPage = () => {
    const state = useModel(UnappliedCashStore);
    const [isReady, setIsReady] = React.useState(false);
    const $activeUnappliedCashCard: Linked<UnappliedCashVaultCard> = useLinked<UnappliedCashVaultCard>(null);
    const unappliedCashVaultPage = useModel(UnappliedCashVaultPage);
    const $selectedUnappliedCashDetailsTab = useLinked("details");
    const refList = React.useRef(null)
    const classes = useStyles();
    const [unappliedCashesVaultCard, setUnappliedCashesVaultCard] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    let [countAll, setCountAll] = React.useState(0);

    useIO(async () => {
        await Promise.all([
            state.payors.fetch(),
            state.payees.fetch()
        ])

        state.initialize()
        await fetchUnappliedCash();
        setCountAll(unappliedCashVaultPage.unappliedCashes.count);
        setUnappliedCashesVaultCard(unappliedCashVaultPage.unappliedCashes.items.models)
    }, []);

    const fetchUnappliedCash = async (skip = 0, count = 100) => {
        const params = state.filter.mapToQuery(skip, count);
        setIsLoading(true)
        await unappliedCashVaultPage.unappliedCashes.fetch({ params: params }).catch(e => console.error(e));
        setIsLoading(false);
        setIsReady(true);
    }

    const closeDetailsPane = () => $activeUnappliedCashCard.set(null);
    const onVaultCardClicked = () => $selectedUnappliedCashDetailsTab.set('details');

    useMemo(async () => {
        if (isReady) {
            setIsReady(false);
            $activeUnappliedCashCard.set(null);
            await fetchUnappliedCash();
            setUnappliedCashesVaultCard(unappliedCashVaultPage.unappliedCashes.items.models);
        }
    }, [state.filter['_changeToken']]);

    return <>
        <Page maxWidth={false} header={
            <Flex center>
                <RowH1 className={classes.title}>Unapplied Cash</RowH1>
            </Flex>
        }
            top={
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <StyledFilterBar filter={state.filter} filterAllPlaceholder="Filter by Payor Name, Payee Name, Amount, Effective Date, Currency or Reference Number" />
                        {/* <StateFilter stateValue={state.filter.$.stateId} filterOptions={RemittanceAdviceStateOptions} /> */}
                        <SelectSortBy $attr={state.filter.sortBy.$.attr} $asc={state.filter.sortBy.$.asc} options={SortOptions} />
                    </Toolbar>
                </AppBar>
            }>
            {
                isReady ?
                    <Columns style={{ minHeight: 'calc(100% - 80px)' }}>
                        <TilesListColumn>
                            <CountListSection countAll={countAll} countFiltered={unappliedCashVaultPage.unappliedCashes.count}></CountListSection>
                            <TilesList
                                items={unappliedCashesVaultCard}
                                itemSize={100}
                                renderer={UnappliedCashVaultCardRenderer($activeUnappliedCashCard, (vaultCard: UnappliedCashVaultCard) => { }, onVaultCardClicked)}
                                selected={undefined}
                            />
                        </TilesListColumn>
                        {$activeUnappliedCashCard.value &&
                            <UnappliedCashDetailsColumn>
                                <UnappliedCashDetailsPane close={closeDetailsPane} unappliedCash={$activeUnappliedCashCard.value.dataset} unappliedCashId={$activeUnappliedCashCard.value.id} $selectedTab={$selectedUnappliedCashDetailsTab} />
                            </UnappliedCashDetailsColumn>}
                    </Columns> : <Loading />
            }
        </Page>
    </>
}

const TilesListColumn = styled(Column)({
    minWidth: '500px',
    minHeight: '250px'
});

const UnappliedCashDetailsColumn = styled(Column)({
    minWidth: '250px'
});

const useStyles = makeStyles({
    title: {
        padding: '20px 0',
        color: '#3d6889',
        fontSize: '24px'
    }
});

const StyledFilterBar = styled(AddFilter)({
    width: '650px',
    alignItems: 'center',
    padding: '4px',
});